/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GiftSubscriptionBody
 */
export interface GiftSubscriptionBody {
    /**
     * 
     * @type {string}
     * @memberof GiftSubscriptionBody
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSubscriptionBody
     */
    priceId: string;
}

/**
 * Check if a given object implements the GiftSubscriptionBody interface.
 */
export function instanceOfGiftSubscriptionBody(value: object): value is GiftSubscriptionBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('priceId' in value) || value['priceId'] === undefined) return false;
    return true;
}

export function GiftSubscriptionBodyFromJSON(json: any): GiftSubscriptionBody {
    return GiftSubscriptionBodyFromJSONTyped(json, false);
}

export function GiftSubscriptionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiftSubscriptionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'priceId': json['priceId'],
    };
}

export function GiftSubscriptionBodyToJSON(json: any): GiftSubscriptionBody {
    return GiftSubscriptionBodyToJSONTyped(json, false);
}

export function GiftSubscriptionBodyToJSONTyped(value?: GiftSubscriptionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'priceId': value['priceId'],
    };
}

